var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"pageIndex":1}}),_vm._v(" "),_c('CBanner',{attrs:{"imgUrl":"/static/banner6.png","title1":"关于我们","title-en":"About Us","titleEn":"About Us","title2":"提供以品牌电子商务为核心的一站式商业解决方案"}}),_vm._v(" "),_c('CTitle',{attrs:{"title":"/static/about-us.png","desc":"About Us"}}),_vm._v(" "),_c('CUs'),_vm._v(" "),_c('CToTop')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ca83de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contains/AboutUs.vue
// module id = null
// module chunks = 